export enum MediaRecordingUploadFailurePhaseEnum {
  ChunkUpload = 'chunk_upload',
  ServerProcessing = 'server_processing',
  YoutubeUpload = 'youtube_upload',
  Unavailable = 'unavailable',
}
